import { useEffect, useRef, type RefObject } from "react";

interface UseInfiniteScrollSentinelArgs {
  hasMore: boolean;
  isLoadingMore: boolean;
  loadMore: () => void;
}

export function useInfiniteScrollSentinel({
  hasMore,
  isLoadingMore,
  loadMore,
}: UseInfiniteScrollSentinelArgs): RefObject<HTMLDivElement | null> {
  const sentinelRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting && hasMore && !isLoadingMore) {
        loadMore();
      }
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, isLoadingMore, loadMore]);

  return sentinelRef;
}
